//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';

export default {
  name: 'Description',
  components: {
    // TruncateTextWithShowMore: () => import('@motionelements/product2025/src/components/TruncateTextWithShowMore.vue'),
  },
  props: {
    text: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showMore: false,
      linesLimit: 3,
      //
      // observer: null,
    };
  },
  computed: {
    ...mapGetters({
      isMobile: 'browser/isMobile',
    }),
  },
  watch: {
    text(val, oldVal) {
      console.log('========= WATCH text ', val, oldVal);
      if (val) {
        setTimeout(() => {
          this.calculateHeight();
        });
      }
    },
  },
  mounted() {
    this.calculateHeight();
    window.addEventListener('resize', this.calculateHeight);
    //
    // const targetNode = this.$refs.truncateText;
    // const config = {
    //   childList: true,
    //   subtree: true,
    //   characterData: true,
    // };
    // this.observer = new MutationObserver((mutationsList) => {
    //   console.log(mutationsList);
    //   // eslint-disable-next-line
    //   for (let mutation of mutationsList) {
    //     console.log(mutation);
    //     if ((mutation.type === 'childList' || mutation.type === 'characterData') && mutation.addedNodes.length) {
    //       if (targetNode.textContent) {
    //         console.log('////////// Text mutation', targetNode.textContent);
    //         this.calculateHeight();
    //       }
    //     }
    //   }
    // });
    //
    // // Start observing the target node with the specified configuration.
    // this.observer.observe(targetNode, config);
  },
  beforeDestroy() {
  //   // Clean up the observer when the component is destroyed to prevent memory leaks.
  //   if (this.observer) {
  //     this.observer.disconnect();
  //   }
    window.removeEventListener('resize', this.calculateHeight);
  },
  methods: {
    calculateHeight() {
      this.$store.commit('browser/setWindowWidth', window.innerWidth);
      if (this.isMobile) {
        this.showMore = false;
      } else if (this.$refs.truncateText) {
        const lineHeight = parseFloat(window.getComputedStyle(this.$refs.truncateText).lineHeight);
        const height = this.$refs.truncateText.scrollHeight;
        if (height > lineHeight * this.linesLimit) {
          this.showMore = true;
        }
      }
    },
    handleShowMore() {
      this.showMore = false;
    },
  },
};
